<script>
    export default {
        props: {
            readmorelabel: String
        }
    }
</script>

<template>
    <div class="card is-shadowless is-flex is-radiusless">
        <div class="card-image">
            <picture class="image is-4by3"><img width="400" height="300" alt="Placeholder image" /></picture>
        </div>
        <div class="card-content is-flex-grow-1 is-flex is-flex-direction-column">
            <div class="mb-2"><div class="progress is-large" value="0" max="100"></div></div>
            <div class="mb-4"><div class="progress" value="0" max="100"></div></div>
            <div v-for="index in 3" :key="index" class="mb-2"><div class="progress" value="0" max="100"></div></div>
            <div v-if="readmorelabel" class="is-flex is-justify-content-end mt-auto">
                <span class="button is-link is-outlined is-radiusless">
                    <span>{{ readmorelabel }}</span>
                    <span class="icon"><i class="fa-solid fa-angle-right"></i></span>
                </span>
            </div>
        </div>
    </div>
</template>
